import { apiClient } from "./apiClient";

export const authGateway = {
  async login(email: string): Promise<void> {
    return await apiClient.post("/auth/login", { email });
  },

  async verifyLogin(code: string): Promise<void> {
    return await apiClient.post("/auth/verify", { code });
  },

  async logout(): Promise<void> {
    return await apiClient.post("/auth/logout");
  },
};
